export default "__VITE_ASSET__Rfi5EI73__"